import 'ant-design-vue/dist/antd.variable.min.css'
import { ConfigProvider } from 'ant-design-vue'
ConfigProvider.config({
  theme: {
    primaryColor: '#FA8919'
  }
})
